import { Component, OnInit } from "@angular/core";

import { SecurityRoute, StorageService, SecurityStorageKey } from "../../../services";
import { Router } from "@angular/router";

@Component({
    selector: "signout-form",
    templateUrl: "./signoutForm.tmpl.html",
    standalone: false
})
export class SignoutFormComponent implements OnInit
{
    constructor(
        private readonly router: Router,
        private readonly $storageService: StorageService,
    )
    { }

    ngOnInit(): void
    {
        // TODO - we should be consolidating stored data access within the appropriate services instead of just hard-coding things all over the place.
        this.$storageService.Remove(SecurityStorageKey.TidToken);
    }

    return(): void
    {
        this.router.navigate([SecurityRoute.Login], { queryParamsHandling: "preserve" });
    }
}
